import { useState, useRef, useCallback } from "react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const parseSseEvents = (chunk) => {
  const parts = chunk.split("\n\n");
  return { events: parts.slice(0, -1), rest: parts[parts.length - 1] };
};

export const useChatStream = (weightRef) => {
  const [messages, setMessages] = useState([]);
  const [streaming, setStreaming] = useState(false);
  const sessionId = useRef(`sess-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`);

  const applyEvent = useCallback((ev, assistantIdRef) => {
    if (ev.delta) {
      if (!assistantIdRef.current) {
        assistantIdRef.current = crypto.randomUUID();
        const id = assistantIdRef.current;
        setMessages((prev) => [...prev, { id, role: "assistant", content: ev.delta }]);
      } else {
        const id = assistantIdRef.current;
        setMessages((prev) => prev.map((m) => (m.id === id ? { ...m, content: m.content + ev.delta } : m)));
      }
    } else if (ev.error) {
      toast.error("AI Copilot error — please try again");
    }
  }, []);

  const streamChat = useCallback(async (message, context) => {
    setMessages((prev) => [...prev, { id: crypto.randomUUID(), role: "user", content: message }]);
    setStreaming(true);
    const assistantIdRef = { current: null };
    try {
      const res = await fetch(`${API}/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId.current, message, context, weight_class: weightRef.current }),
      });
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const { events, rest } = parseSseEvents(buffer);
        buffer = rest;
        for (const line of events) {
          if (line.startsWith("data: ")) applyEvent(JSON.parse(line.slice(6)), assistantIdRef);
        }
      }
    } catch {
      toast.error("Connection lost — please try again");
    }
    setStreaming(false);
  }, [applyEvent, weightRef]);

  return { messages, streaming, streamChat };
};
